import { getMap } from '../../atoms/map/utils/getMap'
import { findLayer } from '../utils/findLayer'

/**
 * Remove all RoadSegments Features from the Map
 */
export function clearRoadSegmentFeatures() {
  const map = getMap()
  const layer = findLayer(map, 'roadSegment')

  layer.getSource()?.clear()
}
